<div style="margin: auto !important;">

    <h2>Anulación OS</h2>

    <app-upload-files [numberOS]="numberOS"></app-upload-files>

    <form (ngSubmit)="submitForm()" #contactForm="ngForm" class="form">
        <div class="form-group" class="divInput">
            <label for="reef">REEF:</label>
            <input type="number" id="reef" name="reef" [(ngModel)]="nota.reef" required>
        </div>

        <div class="form-group" class="divInput">
            <label for="saf">SAF:</label>
            <input type="number" id="saf" name="saf" [(ngModel)]="nota.saf" required>
        </div>


        <div class="form-group" class="divInput">
            <label for="penalidad">PAGO PARCIAL:</label>
            <input type="number" id="partialPayment" name="partialPayment" [(ngModel)]="nota.partialPayment" required>
        </div>

        <div class="form-group" class="divInput">
            <label for="penalidad">PENALIDAD:</label>
            <input type="number" id="penalidad" name="penalidad" [(ngModel)]="nota.penalidad" required>
        </div>

        <div class="divCenter">
            <button type="submit" [disabled]="!contactForm.valid" class="send" class="buttonPrimary">Enviar</button>
        </div>

    </form>
    <div class="divCenter">
        <button (click)="close()" class="close">Cerrar</button>

    </div>


</div>